import Request from '@/plugins/request';

export function getAdvanceLogs(params) {
  return Request.get('advance-logs', { params })
}

export function createAdvanceLog() {
  return Request.get(`advance-logs/create`)
}

export function storeAdvanceLog(data) {
  return Request.post('advance-logs', data)
}

export function updateAdvanceLog(id, data) {
  return Request.put(`advance-logs/${id}`, data)
}

export function editAdvanceLog(id) {
  return Request.get(`advance-logs/${id}/edit`)
}

export function destroyAdvanceLog(id) {
  return Request.delete(`advance-logs/${id}`)
}
